import { validate as validateNewPassword } from '@ynap/password-input'

export default function validate(values, props) {
    const { messages } = props
    const errors = {}

    if (!values.x_logonPasswordCurrent || !values.x_logonPasswordCurrent.trim()) {
        errors.x_logonPasswordCurrent = messages.errors.required({
            field: messages.changePasswordForm.currentPassword(),
        })
    }

    errors.logonPassword = validateNewPassword(values.logonPassword, props)

    if (values.logonPassword === values.x_logonPasswordCurrent) {
        errors.logonPassword = messages.errors.passwordsMatch()
    }

    return errors
}
